// removed by extract-text-webpack-plugin
module.exports = {"albumName":"_1AaL0tRgQmcTPlOcAx8HK4","artistName":"_3gItD4yo6KAIQJwPyeR_W7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AlbumItem/AlbumItemInfo/AlbumItemInfo.scss
// module id = 1239
// module chunks = 1